import { useEffect, useMemo, useState } from "react";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Avatar } from "primereact/avatar";
import { Chip } from "primereact/chip";
import { InputTextarea } from "primereact/inputtextarea";
import { Fetch } from "../../../shared/Fetch";
import { SendEmail } from "./SendEmail";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { Skeleton } from "primereact/skeleton";
import * as pdfjsLib from "pdfjs-dist";
import mammoth from "mammoth";
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

// const candidateOld: Candidate = {
//   city: "Austin",
//   country: "United States",
//   authorizedToWorkInUS: true,
//   needsSponsorshipToWorkInUS: false,
//   authorizedToWorkInCanada: false,
//   needsSponsorshipToWorkInCanada: false,
//   usCitizen: true,

//   currentJobTitle: "Sr. React.JS Developer",
//   currentCompany: "Pfizer",

//   education: [
//     {
//       degree: "Bachelors",
//       location: "Texas City",
//       org: "University of North Texas",
//     },
//   ],

//   email: ["q36-8ea-ukq@mail.dice.com"],

//   experience: {
//     current: {
//       org: "Pfizer",
//       periodStart: {
//         day: 1,
//         month: 10,
//         year: 2022,
//       },
//       title: "Sr. React.JS Developer",
//     },
//     history: [
//       {
//         org: "Pfizer",
//         periodStart: { day: 1, month: 10, year: 2022 },
//         title: "Sr. React.JS Developer",
//       },
//       {
//         org: "Goldman Sachs",
//         periodEnd: { day: 1, month: 10, year: 2022 },
//         periodStart: { day: 1, month: 10, year: 2021 },
//         title: "Sr. React.JS Developer",
//       },
//       {
//         org: "Lear Corporation",
//         periodEnd: { day: 1, month: 10, year: 2021 },
//         periodStart: { day: 1, month: 4, year: 2020 },
//         title: "Sr. React.JS Developer",
//       },
//     ],
//   },

//   firstName: "Cooper",
//   lastName: "Brown",
//   fullName: "Cooper Brown",

//   dateLastActive: "2024-06-07T11:49:21Z",
//   dateLastUpdated: "2024-06-21T13:49:30Z",
//   dateResumeLastUpdated: "2024-05-01T12:37:47.482Z",

//   desiredJobTitles: ["Senior React Developer"],

//   hasEmail: true,
//   hasPhone: false,

//   id: "a6d0733de3631302bad036f20d643a74d780c195",
//   candidateId: "a8217da6-2a5d-4812-83fc-17ccaef1afec",

//   legacyIds: ["a6d0733de3631302bad036f20d643a74d780c195", "5afab5a87b715eac60b86c53db899e3b6d904345", "9e6a60ab16f1d85dbc2f84916ef203cf"],

//   isThirdParty: false,

//   likelyToMove: false,
//   likelyToMoveScore: 0,

//   locations: [
//     {
//       city: "Austin",
//       country: "United States",
//       countryCode: "US",
//       latitude: 30.2961711883545,
//       longitude: -97.7389526367188,
//       postalCode: "78705",
//       region: "Texas",
//       source: "dice",
//       text: "Austin, Texas, United States",
//     },
//   ],

//   phone: [],
//   region: "Texas",

//   resume: {
//     contentType: "application/pdf",
//     filename: "Converted.pdf",
//     resumeHtml: "",
//     resumeData:
//       "JVBERi0xLjQKMSAwIG9iago8PAovVGl0bGUgKFJlc3VtZSkKL0NyZWF0b3IgKE1hbnVhbCkKL1Byb2R1Y2VyIChNYW51YWwpCi9DcmVhdGlvbkRhdGUgKEQ6MjAyNDAxMDEpCj4+CmVuZG9iagoyIDAgb2JqCjw8Ci9UeXBlIC9DYXRhbG9nCi9QYWdlcyAzIDAgUgo+PgplbmRvYmoKMyAwIG9iago8PAovVHlwZSAvUGFnZXMKL0tpZHMgWzQgMCBSXQovQ291bnQgMQo+PgplbmRvYmoKNCAwIG9iago8PAovVHlwZSAvUGFnZQovUGFyZW50IDMgMCBSCi9NZWRpYUJveCBbMCAwIDYxMiA3OTJdCi9Db250ZW50cyA1IDAgUgovUmVzb3VyY2VzIDw8Ci9Gb250IDw8Ci9GMSA2IDAgUgo+Pgo+Pgo+PgplbmRvYmoKNSAwIG9iago8PAovTGVuZ3RoIDQ0NAo+PgpzdHJlYW0KQlQKL0YxIDI0IFRmCjUwIDcyMCBUZAooQ29vcGVyIEJyb3duKSBUagowIC0zNiBURgovRjEgMTQgVGYKKFNyLiBSZWFjdC5KUyBEZXZlbG9wZXIpIFRqCjAgLTI0IFRECihQZml6ZXIgfCBBdXN0aW4sIFRleGFzKSBUagowIC00OCBURC9GMSAxMiBUZgooRVhQRVJJRU5DRSkgVGoKMCAtMjAgVEQKL0YxIDExIFRmCihTci4gUmVhY3QuSlMgRGV2ZWxvcGVyIC0gUGZpemVyKSBUagowIC0xNiBURApPY3QgMjAyMiAtIFByZXNlbnQpIFRqCjAgLTIwIFRECihTci4gUmVhY3QuSlMgRGV2ZWxvcGVyIC0gR29sZG1hbiBTYWNocykgVGoKMCAtMTYgVEQKKE9jdCAyMDIxIC0gT2N0IDIwMjIpIFRqCjAgLTIwIFRECihTci4gUmVhY3QuSlMgRGV2ZWxvcGVyIC0gTGVhciBDb3Jwb3JhdGlvbikgVGoKMCAtMTYgVEQKKEFwciAyMDIwIC0gT2N0IDIwMjEpIFRqCjAgLTQ4IFREL0YxIDEyIFRmCihFRFVDQVRJT04pIFRqCjAgLTIwIFRECi9GMSAxMSBUZgooQmFjaGVsb3JzIC0gVW5pdmVyc2l0eSBvZiBOb3J0aCBUZXhhcykgVGoKMCAtNDggVEQKL0YxIDEyIFRmCihTS0lMTFMpIFRqCjAgLTIwIFRECi9GMSAxMSBUZgooUmVhY3QsIFJlZHV4LCBUWXBlU2NyaXB0LCBKYW1TY3JpcHQsIE5vZGUuanMsIEFXUywgQ1NTLCBIVE1MNSkgVGoKRVQKZW5kc3RyZWFtCmVuZG9iago2IDAgb2JqCjw8Ci9UeXBlIC9Gb250Ci9TdWJ0eXBlIC9UeXBlMQovQmFzZUZvbnQgL0hlbHZldGljYQo+PgplbmRvYmoKeHJlZgowIDcKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDA5IDAwMDAwIG4gCjAwMDAwMDAxMDYgMDAwMDAgbiAKMDAwMDAwMDE1OCAwMDAwMCBuIAowMDAwMDAwMjE3IDAwMDAwIG4gCjAwMDAwMDA0MTMgMDAwMDAgbiAKMDAwMDAwMDkwNyAwMDAwMCBuIAp0cmFpbGVyCjw8Ci9TaXplIDcKL1Jvb3QgMiAwIFIKPj4Kc3RhcnR4cmVmCjk3OQolJUVPRgo=",
//   },

//   skills: [
//     { lastUsed: 2026, skill: "react", yearsUsed: 10 },
//     { lastUsed: 2026, skill: "redux", yearsUsed: 10 },
//     { lastUsed: 2026, skill: "accessibility", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "amazon web services", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "api", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "css", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "html5", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "java", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "javascript", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "node.js", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "oop", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "php", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "qa", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "restful", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "typescript", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "unit testing", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "web services", yearsUsed: 9 },
//     { lastUsed: 2026, skill: "ajax", yearsUsed: 8 },
//     { lastUsed: 2026, skill: "json", yearsUsed: 8 },
//   ],

//   socialProfiles: [
//     {
//       icon_64: "https://dmf1ol3sc7oaa.cloudfront.net/64/dice.png",
//       source: "Dice",
//       url: "https://www.dice.com/employer/talent/profile/9e6a60ab16f1d85dbc2f84916ef203cf",
//     },
//   ],

//   workPermitDocuments: ["US Citizen"],
//   workPermitLocations: ["US"],

//   workPreferences: [
//     {
//       employmentType: ["Contract - Corp-to-Corp", "Contract - W2", "Contract to Hire - Corp-to-Corp", "Contract to Hire - W2"],
//       annualSalary: {
//         currency: "USD",
//         max: 0,
//         min: 100000,
//       },
//       hourlyRate: {
//         currency: "USD",
//         max: 0,
//         min: 60,
//       },
//       willingToRelocate: false,
//       travelPreference: 0,
//     },
//   ],

//   yearsOfExperience: 6,

//   usage: {
//     customerId: 2102208,
//     quota: 200,
//     viewsConsumed: 4,
//     viewsRemaining: 196,
//   },

//   securityAllowance: {
//     status: false,
//   },

//   desiredWorkSettings: ["REMOTE"],
// };

// ─── Types ────────────────────────────────────────────────────────────────
interface Period {
  day: number;
  month: number;
  year: number;
}
interface ExperienceEntry {
  org: string;
  title: string;
  periodStart: Period;
  periodEnd?: Period;
}
interface Skill {
  skill: string;
  yearsUsed: number;
  lastUsed: number;
}
interface Location {
  city: string;
  region: string;
  country: string;
  countryCode: string;
  postalCode?: string;
  text: string;

  latitude?: number;
  longitude?: number;
  source?: string;
}
interface SocialProfile {
  source: string;
  url: string;
  icon_64?: string;
}
interface WorkPreference {
  employmentType: string[];
  annualSalary: { currency: string; min: number; max: number };
  hourlyRate: { currency: string; min: number; max: number };
  willingToRelocate: boolean;
  travelPreference: number;
}
interface Education {
  degree: string;
  org: string;
  location: string;
}
interface Usage {
  customerId: number;
  quota: number;
  viewsConsumed: number;
  viewsRemaining: number;
}

interface Candidate {
  // Identity
  consultant_ID?: number;
  id?: string;
  candidateId?: string;
  legacyIds?: string[];

  firstName?: string;
  lastName?: string;
  fullName?: string;
  city?: string;
  region?: string;
  country?: string;
  locations?: Location[];

  // Job
  currentJobTitle?: string;
  currentCompany?: string;
  yearsOfExperience?: number;
  desiredJobTitles?: string[];

  // Experience
  experience?: { current: ExperienceEntry; history: ExperienceEntry[] };

  // Education
  education?: Education[];

  // Skills
  skills?: Skill[];

  // Work prefs
  workPreferences?: WorkPreference[];
  desiredWorkSettings?: string[];

  // Auth
  usCitizen?: boolean;
  authorizedToWorkInUS?: boolean;
  needsSponsorshipToWorkInUS?: boolean;
  authorizedToWorkInCanada?: boolean;
  needsSponsorshipToWorkInCanada?: boolean;
  workPermitDocuments?: string[];
  workPermitLocations?: string[];

  // Contact
  email?: string[];
  phone?: string[];
  hasEmail?: boolean;
  hasPhone?: boolean;

  // Social
  socialProfiles?: SocialProfile[];

  // Flags
  likelyToMove?: boolean;
  likelyToMoveScore?: number;
  isThirdParty?: boolean;
  securityAllowance?: { status: boolean };

  // Dates
  dateLastActive?: string;
  dateLastUpdated?: string;
  dateResumeLastUpdated?: string;

  // Usage
  usage?: Usage;

  // Resume
  resume?: { contentType: string; filename: string; resumeData: string; resumeHtml: string };
}

// ─── Helpers ──────────────────────────────────────────────────────────────
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const formatPeriod = (p: Period) => `${MONTHS[p.month - 1]} ${p.year}`;

const timeSince = (dateStr: string) => {
  const days = Math.floor((Date.now() - new Date(dateStr).getTime()) / 86400000);
  if (days > 30) return "30+ days ago";
  if (days === 0) return "Today";
  return `${days} day${days !== 1 ? "s" : ""} ago`;
};

const workAuth = (c: Candidate) => {
  // if (c.usCitizen) return "US Citizen";
  // if (c.needsSponsorshipToWorkInUS) return "Needs H1 Visa";
  // if (c.authorizedToWorkInUS) return "Authorized (No Sponsorship)";
  return c.workPermitDocuments?.join(", ") || "Not specified";
};

// ─── Shared UI ────────────────────────────────────────────────────────────
const Section = ({ title, icon, children }: { title: string; icon: string; children: React.ReactNode }) => (
  <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e9f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
    <div className="flex align-items-center gap-2 mb-3">
      <i className={icon} style={{ color: "#0d6efd", fontSize: "1rem" }} />
      <span style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1d23" }}>{title}</span>
    </div>
    {children}
  </Card>
);

const LabelValue = ({ label, value, highlight }: { label: string; value: React.ReactNode; highlight?: boolean }) => (
  <div className="mb-3">
    <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "#8392a5", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "0.25rem" }}>{label}</div>
    {highlight ? <Tag value={value as string} style={{ background: "#e3f2fd", color: "#1565c0", fontWeight: 600, fontSize: "0.8rem" }} /> : <div style={{ fontWeight: 600, color: "#1a1d23", fontSize: "0.9rem" }}>{value}</div>}
  </div>
);

interface IProps {
  visible: boolean;
  singleData: any;
  toast: any;
  filters: any;
}

const isValidBase64 = (str: string): boolean => {
  if (!str || str.length < 64) return false;
  const stripped = str.startsWith("data:") ? str.split(",")[1] : str;
  return /^[A-Za-z0-9+/\s]+=*$/.test(stripped.trim());
};

// ─── Main ─────────────────────────────────────────────────────────────────
export default function CandidateProfile(props: IProps) {
  const [note, setNote] = useState("");
  const [savedNotes, setSavedNotes] = useState<{ comments?: string; user_Name?: string; createdOn?: Date; company_Name?: string; branchName?: string }[]>([]);
  // const [tag, setTag] = useState<string | null>(null);
  // const [addedTags, setAddedTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [zoom, setZoom] = useState(100);
  const [viewMode, setViewMode] = useState<"scroll" | "page">("scroll");
  const [currentPage, setCurrentPage] = useState(1);
  const [candidate, setCandidate] = useState<Candidate>({});
  const [sendEmail, setSendEmail] = useState({ open: false, tableData: {} } as { open: boolean; tableData: Candidate });
  const [openViewHistory, setOpenViewHistory] = useState({ open: false, tableData: [] } as { open: boolean; tableData: { comments?: string; user_Name?: string; createdOn?: Date; company_Name?: string; branchName?: string }[] });
  // const [html, setHtml] = useState<string>("");
  // const [isPdf, setIsPdf] = useState<boolean>(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DataFormat = loginObj.date_Format;

  // Derived values from exact JSON fields
  const loc = candidate.locations?.[0];
  const pref = candidate.workPreferences?.[0];
  const initials = `${candidate.firstName?.[0] ?? ""}${candidate.lastName?.[0] ?? ""}`.toUpperCase();
  // const totalPages = candidate.resume?.pageCount ?? 1;
  // const totalPages = candidate.resume;
  // const totalPages = 1;
  // const hasResume = !!candidate.resume?.resumeData && candidate.resume.resumeData.length > 0;
  const hasResume = !!candidate.resume?.resumeData && candidate.resume.resumeData.length > 0 && isValidBase64(candidate.resume.resumeData);

  // const resumeSrc = hasResume ? `data:${candidate.resume!.contentType};base64,${candidate.resume!.resumeData}` : undefined;
  // const iframeSrc = resumeSrc && viewMode === "page" ? `${resumeSrc}#page=${currentPage}` : resumeSrc;
  // const iframeSrc = candidate.resume?.resumeData?.startsWith("data:") ? candidate.resume.resumeData : `data:application/pdf;base64,${candidate.resume?.resumeData}`;
  // const iframeSrc = useMemo(() => {
  //   if (!hasResume) return undefined;
  //   try {
  //     const base64 = candidate.resume!.resumeData.startsWith("data:") ? candidate.resume!.resumeData.split(",")[1] : candidate.resume!.resumeData;
  //     const binary = atob(base64);
  //     const bytes = new Uint8Array(binary.length);
  //     for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  //     const blob = new Blob([bytes], { type: "application/pdf" });
  //     return URL.createObjectURL(blob);
  //   } catch {
  //     return undefined;
  //   }
  // }, [hasResume]);

  const searchKeywords = useMemo(() => {
    const raw = props.filters?.q || "";

    if (!raw.trim()) return [];

    return (
      raw
        .match(/"[^"]+"|\b[^,\s()]+\b/g)
        ?.map((kw: string) => kw.replace(/["']/g, "").trim())
        .filter((kw: string) => !/^(AND|OR|NOT|&)$/i.test(kw)) || []
    );
  }, [props.filters]);

  // console.log("Filters received:", props.filters);
  // console.log("Search keyword for highlighting:", searchKeywords);

  useEffect(() => {
    if (!candidate.resume?.resumeData) return;

    let isCancelled = false;

    const processFile = async () => {
      try {
        if (fileUrl) {
          URL.revokeObjectURL(fileUrl);
          setFileUrl(null);
        }

        const rawData = candidate.resume?.resumeData;
        const contentType = candidate.resume?.contentType || "";
        const resumeHtml = candidate.resume?.resumeHtml;

        // ─── 1. Use resumeHtml if it's real HTML (highest priority) ──────────────
        if (resumeHtml && resumeHtml.trim().length > 0 && resumeHtml.trim().toLowerCase() !== "updated html" && /<[a-z][\s\S]*>/i.test(resumeHtml)) {
          const highlighted = highlightInHtml(resumeHtml, searchKeywords);
          const blob = new Blob([highlighted], { type: "text/html;charset=utf-8" });
          if (isCancelled) return;
          setFileUrl(URL.createObjectURL(blob));
          return;
        }

        // ─── 2. Validate base64 ───────────────────────────────────────────────────
        if (!rawData || !isValidBase64(rawData)) {
          console.warn("resumeData is not valid base64 — got:", rawData);
          setFileUrl(null);
          return;
        }

        // ─── 3. Decode base64 → bytes ─────────────────────────────────────────────
        const base64 = rawData.startsWith("data:") ? rawData.split(",")[1] : rawData;

        let bytes: Uint8Array;
        try {
          const binary = atob(base64);
          bytes = new Uint8Array(binary.length);
          for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        } catch (decodeErr) {
          console.error("Failed to decode base64 resumeData:", decodeErr);
          setFileUrl(null);
          return;
        }

        if (isCancelled) return;

        // ─── 4. Route by contentType ──────────────────────────────────────────────

        // ── 4a. DOCX ──────────────────────────────────────────────────────────────
        if (contentType.includes("wordprocessingml") || contentType.includes("msword") || candidate.resume?.filename?.toLowerCase().endsWith(".docx") || candidate.resume?.filename?.toLowerCase().endsWith(".doc")) {
          try {
            const result = await mammoth.convertToHtml({ arrayBuffer: bytes.buffer as ArrayBuffer });
            const highlighted = highlightInHtml(result.value, searchKeywords);
            const html = `<html><head><style>
            body { font-family: Arial, sans-serif; padding: 24px; max-width: 900px; margin: auto; line-height: 1.6; }
          </style></head><body>${highlighted}</body></html>`;
            const blob = new Blob([html], { type: "text/html;charset=utf-8" });
            if (isCancelled) return;
            setFileUrl(URL.createObjectURL(blob));
          } catch (docxErr) {
            console.error("Failed to parse DOCX:", docxErr);
            setFileUrl(null);
          }
          return;
        }

        // ── 4b. Plain text / RTF ──────────────────────────────────────────────────
        if (contentType.includes("text/plain") || contentType.includes("text/rtf") || candidate.resume?.filename?.toLowerCase().endsWith(".txt") || candidate.resume?.filename?.toLowerCase().endsWith(".rtf")) {
          const text = new TextDecoder("utf-8").decode(bytes);
          const escaped = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
          const highlighted = highlightInHtml(`<pre style="white-space:pre-wrap;word-break:break-word;">${escaped}</pre>`, searchKeywords);
          const html = `<html><head><style>
          body { font-family: monospace; padding: 24px; background: #fff; }
        </style></head><body>${highlighted}</body></html>`;
          const blob = new Blob([html], { type: "text/html;charset=utf-8" });
          if (isCancelled) return;
          setFileUrl(URL.createObjectURL(blob));
          return;
        }

        // ── 4c. Images (jpg, png, gif, webp) ─────────────────────────────────────
        if (contentType.startsWith("image/")) {
          const blob = new Blob([bytes.buffer as ArrayBuffer], { type: contentType });
          const imgUrl = URL.createObjectURL(blob);
          const html = `<html><head><style>
          body { margin:0; background:#f4f4f4; display:flex; justify-content:center; padding:16px; }
          img { max-width:100%; box-shadow:0 2px 8px rgba(0,0,0,0.2); border-radius:4px; }
        </style></head><body><img src="${imgUrl}" /></body></html>`;
          const htmlBlob = new Blob([html], { type: "text/html;charset=utf-8" });
          if (isCancelled) return;
          setFileUrl(URL.createObjectURL(htmlBlob));
          return;
        }

        // ── 4d. PDF (default fallback) ────────────────────────────────────────────
        let pdf: pdfjsLib.PDFDocumentProxy;
        try {
          pdf = await pdfjsLib.getDocument({ data: bytes }).promise;
        } catch (pdfErr) {
          console.error("Failed to parse PDF:", pdfErr);
          setFileUrl(null);
          return;
        }

        const kwPattern =
          searchKeywords.length > 0
            ? new RegExp(
                `(${searchKeywords
                  .map((k: string) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
                  .sort((a: string, b: string) => b.length - a.length)
                  .join("|")})`,
                "gi",
              )
            : null;

        let pagesHtml = `<html><head><style>
        body { margin:0; padding:16px; background:#f4f4f4; }
        .page-wrap { position:relative; background:#fff; margin-bottom:16px;
          box-shadow:0 2px 8px rgba(0,0,0,0.15); border-radius:4px; overflow:hidden; display:inline-block; }
        img { display:block; }
      </style></head><body>`;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const scale = 1.8;
          const viewport = page.getViewport({ scale });

          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          const ctx = canvas.getContext("2d")!;

          await page.render({ canvasContext: ctx, viewport, canvas }).promise;

          if (kwPattern) {
            const textContent = await page.getTextContent();
            const items = textContent.items as any[];

            for (const item of items) {
              if (!item.str?.trim()) continue;
              kwPattern.lastIndex = 0;
              if (!kwPattern.test(item.str)) continue;

              const tx = pdfjsLib.Util.transform(viewport.transform, item.transform);
              const itemX = tx[4];
              const itemY = tx[5];
              const itemWidthPx = item.width * scale;
              const fontHeightPx = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]) || Math.abs(tx[0]);

              kwPattern.lastIndex = 0;
              let match: RegExpExecArray | null;

              while ((match = kwPattern.exec(item.str)) !== null) {
                const matchStart = match.index;
                const matchEnd = matchStart + match[0].length;
                const totalLen = item.str.length;
                const xStart = itemX + (matchStart / totalLen) * itemWidthPx;
                const xEnd = itemX + (matchEnd / totalLen) * itemWidthPx;
                const rectW = xEnd - xStart;
                const rectH = fontHeightPx * 1.1;
                const rectY = itemY - fontHeightPx * 0.85;

                ctx.save();
                ctx.globalAlpha = 0.4;
                ctx.fillStyle = "#FFD700";
                ctx.fillRect(xStart, rectY, rectW, rectH);
                ctx.restore();
              }
            }
          }

          if (isCancelled) return;

          const dataUrl = canvas.toDataURL("image/png");
          pagesHtml += `
          <div class="page-wrap" style="width:${viewport.width}px;">
            <img src="${dataUrl}" width="${viewport.width}" height="${viewport.height}" />
          </div>`;
        }

        pagesHtml += `</body></html>`;
        const blob = new Blob([pagesHtml], { type: "text/html;charset=utf-8" });
        if (isCancelled) return;
        setFileUrl(URL.createObjectURL(blob));
      } catch (e) {
        console.error("Error processing resume", e);
        setFileUrl(null);
      }
    };

    processFile();
    return () => {
      isCancelled = true;
    };
  }, [searchKeywords, candidate.resume?.resumeData, candidate.resume?.resumeHtml]);

  const loaddata = async () => {
    setCandidate({});
    setLoading(true);
    setFileUrl(null);
    const response = await Fetch("MassMail/searchByID", "GET", null, `profile_ID=${props.singleData.candidateId}`, props.toast);
    if (response) {
      const data: Candidate = await response?.json();
      setCandidate(data);
    }
    setLoading(false);
  };

  const saveCandidateNote = async () => {
    if (candidate.consultant_ID !== undefined && candidate.consultant_ID !== null && candidate.consultant_ID > 0 && note.trim() !== "") {
      // setLoading(true);
      const body = {
        consultant_ID: candidate.consultant_ID,
        comments: note,
      };

      const response = await Fetch("Consultant_Mast/addEditConsultantNote", "POST", body, null, props.toast);
      if (response) {
        props.toast.current.show({ severity: "success", detail: "Comment Added Successfully", life: 3000 });
        setNote("");
        getCandidateNotes();
        // setLoading(false);
      }
      // else setLoading(false);
    }
  };

  const getCandidateNotes = async () => {
    const response = await Fetch("MassMail/getCandidateNote", "GET", null, `consID=${candidate.consultant_ID}`, props.toast);
    if (response) {
      const data: { comments?: string; user_Name?: string; createdOn?: Date; company_Name?: string; branchName?: string }[] = await response.json();
      setSavedNotes(data);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    props.toast.current.show({ severity: "success", detail: "Copied Consultant ID", life: 3000 });
  };

  useEffect(() => {
    if (props.visible === true && props.singleData.candidateId) {
      loaddata();
    }
  }, [props.visible]);

  useEffect(() => {
    if (candidate.consultant_ID) {
      getCandidateNotes();
    }
  }, [candidate]);

  const highlightInHtml = (htmlString: string, keywords: string[]): string => {
    if (!keywords.length) return htmlString;

    const filteredKeywords = keywords.filter((k) => k.trim());
    if (!filteredKeywords.length) return htmlString;

    const pattern = filteredKeywords.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");

    const matchRegex = new RegExp(`(${pattern})`, "gi");

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        const tag = parent.tagName.toLowerCase();
        if (tag === "style" || tag === "script") return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const textNodes: Text[] = [];
    let node: Node | null;
    while ((node = walker.nextNode())) {
      textNodes.push(node as Text);
    }

    for (const textNode of textNodes) {
      const original = textNode.nodeValue || "";
      if (!original.trim()) continue;

      matchRegex.lastIndex = 0;
      if (!matchRegex.test(original)) {
        matchRegex.lastIndex = 0;
        continue;
      }
      matchRegex.lastIndex = 0;

      const parts = original.split(matchRegex);
      const fragment = doc.createDocumentFragment();

      for (const part of parts) {
        if (!part) continue;
        if (new RegExp(`^(${pattern})$`, "gi").test(part)) {
          const mark = doc.createElement("mark");
          mark.style.cssText = "background:#fff176 !important;color:#000 !important;padding:0 2px;border-radius:2px;";
          mark.textContent = part;
          fragment.appendChild(mark);
        } else {
          fragment.appendChild(doc.createTextNode(part));
        }
      }

      textNode.parentNode?.replaceChild(fragment, textNode);
    }

    return doc.documentElement.outerHTML;
  };
  return (
    <>
      <div style={{ background: "#f4f6fb", fontFamily: "'Inter', sans-serif", minHeight: "100%" }}>
        {loading ? (
          <div className="card">
            <div className="border-round border-1 surface-border p-4 surface-card">
              <div className="flex mb-3">
                <Skeleton shape="circle" size="4rem" className="mr-2" />
                <div>
                  <Skeleton width="10rem" className="mb-2" />
                  <Skeleton width="5rem" className="mb-2" />
                  <Skeleton height=".5rem" />
                </div>
              </div>
              <Skeleton width="100%" height="150px" />
              <div className="flex justify-content-between mt-3">
                <Skeleton width="4rem" height="2rem" />
                <Skeleton width="4rem" height="2rem" />
              </div>
            </div>
          </div>
        ) : (
          <>
            <Card className="mb-3" style={{ borderRadius: "10px", border: "1px solid #e5e9f0", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
              <div className="flex align-items-start gap-3 flex-wrap">
                <Avatar
                  label={initials}
                  shape="circle"
                  style={{
                    width: "64px",
                    height: "64px",
                    fontSize: "1.4rem",
                    fontWeight: 700,
                    flexShrink: 0,
                    background: "linear-gradient(135deg,#0d6efd,#6610f2)",
                    color: "#fff",
                  }}
                />

                {/* Info */}
                <div style={{ flex: 1, minWidth: "200px" }}>
                  {/* Name */}
                  <div style={{ fontSize: "1.35rem", fontWeight: 700, color: "#1a1d23", lineHeight: 1.2 }}>
                    {candidate.fullName}{" "}
                    <b style={{ border: "1px solid rgb(229, 233, 240)", borderRadius: "10%", padding: "5px", cursor: "pointer" }} onClick={() => copyToClipboard(`${candidate.consultant_ID}` || "")}>
                      {candidate.consultant_ID} <span className="pi pi-clone"></span>
                    </b>
                  </div>

                  {/* Title @ Company */}
                  <div className="flex align-items-center gap-2 mt-1 flex-wrap mt-3">
                    <span style={{ background: "#fff3cd", color: "#856404", padding: "2px 10px", borderRadius: "6px", fontWeight: 600, fontSize: "0.82rem" }}>{candidate.currentJobTitle}</span>
                    <span style={{ color: "#6c757d", fontSize: "0.88rem" }}>@ {candidate.currentCompany}</span>
                  </div>

                  {/* Meta chips */}
                  <div className="flex gap-2 mt-2 flex-wrap">
                    <Chip label={`📍 ${loc?.city ?? candidate.city}, ${loc?.region ?? candidate.region}`} style={{ fontSize: "0.78rem", background: "#f0f4ff", color: "#0d6efd" }} />
                    {candidate.desiredWorkSettings?.map((s) => (
                      <Chip key={s} label={`💻 ${s}`} style={{ fontSize: "0.78rem", background: "#e8f5e9", color: "#2e7d32" }} />
                    ))}
                    <Chip label={`🎓 ${candidate.yearsOfExperience} yrs exp`} style={{ fontSize: "0.78rem", background: "#f3e5f5", color: "#7b1fa2" }} />
                    <Chip label={workAuth(candidate)} style={{ fontSize: "0.78rem", background: "#e3f2fd", color: "#1565c0" }} />
                  </div>
                </div>

                {/* Action buttons */}
                {/* <div className="flex gap-2 flex-shrink-0">
            <Button icon="pi pi-download" tooltip="Download Resume" tooltipOptions={{ position: "top" }} style={{ borderRadius: "8px" }} />
            <Button icon="pi pi-share-alt" tooltip="Share" tooltipOptions={{ position: "top" }} style={{ borderRadius: "8px" }} />
            <Button icon="pi pi-user-plus" tooltip="Add to Pipeline" tooltipOptions={{ position: "top" }} style={{ borderRadius: "8px", background: "#0d6efd", border: "none" }} />
          </div> */}
              </div>
            </Card>
            {/*  ════ ════ ════ ════ LEFT COLUMN ═══ ════ ════ ════ ════ ════ ════ ════ */}
            <div className="grid" style={{ margin: 0 }}>
              <div className="col-12 lg:col-8" style={{ paddingRight: "0.75rem" }}>
                {/* HIGHLIGHTS */}
                <Section title="Highlights" icon="pi pi-star">
                  <div className="grid" style={{ margin: 0 }}>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Years of Experience" value={`${candidate.yearsOfExperience} years`} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Desired Work Type" value={pref?.employmentType?.[0] ?? "Not specified"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Location" value={loc?.text ?? `${candidate.city}, ${candidate.region}`} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Likely to Switch" value={<Tag value={candidate.likelyToMove ? "Likely" : "Unlikely"} style={{ background: candidate.likelyToMove ? "#e8f5e9" : "#fff3e0", color: candidate.likelyToMove ? "#2e7d32" : "#e65100", fontWeight: 600, fontSize: "0.78rem" }} />} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Desired Work Setting" value={candidate.desiredWorkSettings?.join(", ") || "Not specified"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Work Authorization" value={workAuth(candidate)} highlight />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Desired Job Titles" value={candidate.desiredJobTitles?.join(", ") || "Not specified"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Third Party" value={candidate.isThirdParty ? "Yes" : "No"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Security Clearance" value={candidate.securityAllowance?.status ? "Yes" : "No"} />
                    </div>
                  </div>
                </Section>

                {/* SKILLS */}
                <Section title="Skills" icon="pi pi-code">
                  <div style={{ display: "flex", flexWrap: "wrap", margin: 0, gap: "0.4rem" }}>
                    {candidate.skills?.map(({ skill, yearsUsed, lastUsed }) => (
                      <div
                        key={skill}
                        style={{
                          flex: "1 1 calc(33% - 0.4rem)",
                          minWidth: "140px",
                          maxWidth: "100%",
                          background: "#f8f9fb",
                          borderRadius: "8px",
                          padding: "0.5rem 0.75rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #e5e9f0",
                          gap: "0.4rem",
                          boxSizing: "border-box",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#1a1d23",
                            fontSize: "0.82rem",
                            textTransform: "capitalize",
                            flex: 1,
                            minWidth: 0,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {skill}
                        </span>
                        <div style={{ display: "flex", gap: "0.25rem", flexShrink: 0 }}>
                          <Tag value={`${yearsUsed}yr`} style={{ background: "#e3f2fd", color: "#1565c0", fontSize: "0.68rem", fontWeight: 700 }} />
                          <Tag value={String(lastUsed)} style={{ background: "#f3e5f5", color: "#7b1fa2", fontSize: "0.68rem", fontWeight: 700 }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </Section>

                {/* WORK PREFERENCES */}
                <Section title="Work Preferences" icon="pi pi-briefcase">
                  <div className="grid" style={{ margin: 0 }}>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Work Setting" value={candidate.desiredWorkSettings?.join(", ") || "—"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Willing to Relocate" value={pref?.willingToRelocate ? "Yes" : "No"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Travel Preference" value={pref?.travelPreference === 0 ? "No travel" : `${pref?.travelPreference}%`} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Min Hourly Rate" value={pref?.hourlyRate?.min != null ? `$${pref.hourlyRate.min}/hr` : "—"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Min Annual Salary" value={pref?.annualSalary?.min != null ? `$${pref.annualSalary.min.toLocaleString()}` : "—"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Salary Currency" value={pref?.annualSalary?.currency ?? "USD"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Work Permit" value={candidate.workPermitDocuments?.join(", ") || "—"} />
                    </div>
                    <div className="col-6 md:col-4">
                      <LabelValue label="Permit Locations" value={candidate.workPermitLocations?.join(", ") || "—"} />
                    </div>
                  </div>

                  <Divider style={{ margin: "1rem 0 0.75rem" }} />
                  <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "#8392a5", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "0.5rem" }}>Employment Types</div>
                  <div className="flex flex-wrap gap-2">
                    {pref?.employmentType?.map((t) => (
                      <Chip key={t} label={t} style={{ fontSize: "0.78rem", background: "#f0f4ff", color: "#0d6efd" }} />
                    ))}
                  </div>
                </Section>

                {/* WORK HISTORY */}
                <Section title="Work History" icon="pi pi-history">
                  <div style={{ position: "relative", paddingLeft: "1.5rem" }}>
                    {/* vertical line */}
                    <div style={{ position: "absolute", left: "7px", top: "8px", bottom: "8px", width: "2px", background: "#e5e9f0" }} />

                    {candidate.experience?.history?.map((job, i) => (
                      <div key={i} style={{ position: "relative", marginBottom: i < (candidate?.experience?.history || "").length - 1 ? "1.5rem" : 0 }}>
                        {/* dot */}
                        <div
                          style={{
                            position: "absolute",
                            left: "-1.5rem",
                            top: "5px",
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            background: i === 0 ? "#0d6efd" : "#dee2e6",
                            border: "2px solid #fff",
                            boxShadow: `0 0 0 2px ${i === 0 ? "#0d6efd" : "#dee2e6"}`,
                          }}
                        />

                        <div className="flex justify-content-between align-items-start flex-wrap gap-1">
                          <div>
                            <span style={{ background: "#fff3cd", color: "#856404", padding: "1px 8px", borderRadius: "5px", fontSize: "0.8rem", fontWeight: 600 }}>{job.title}</span>
                            <div style={{ color: "#495057", fontWeight: 600, marginTop: "0.3rem", fontSize: "0.88rem" }}>@ {job.org}</div>
                          </div>
                          <div style={{ fontSize: "0.8rem", color: "#8392a5", fontWeight: 500, textAlign: "right", flexShrink: 0 }}>
                            {job.periodStart ? formatPeriod(job.periodStart) : "—"}
                            {" — "}
                            {job.periodEnd ? formatPeriod(job.periodEnd) : <span style={{ color: "#0d6efd", fontWeight: 600 }}>Present</span>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Section>

                {/* EDUCATION */}
                <Section title="Education" icon="pi pi-book">
                  {candidate.education?.map((edu, i) => (
                    <div key={i} className="flex gap-3 align-items-start mb-2">
                      <div style={{ width: "38px", height: "38px", borderRadius: "9px", background: "#e3f2fd", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <i className="pi pi-graduation-cap" style={{ color: "#1565c0", fontSize: "1rem" }} />
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, color: "#1a1d23", fontSize: "0.92rem" }}>{edu.degree}</div>
                        <div style={{ color: "#495057", fontSize: "0.86rem" }}>{edu.org}</div>
                        <div style={{ color: "#8392a5", fontSize: "0.8rem" }}>{edu.location}</div>
                      </div>
                    </div>
                  ))}
                </Section>

                {/* SOCIAL LINKS */}
                <Section title="Social Links" icon="pi pi-link">
                  <div className="flex flex-wrap gap-2">
                    {candidate.socialProfiles?.map((p) => (
                      <a
                        key={p.source}
                        href={p.url}
                        target="_blank"
                        rel="noreferrer"
                        className="flex align-items-center gap-2"
                        style={{ background: "#f0f4ff", padding: "0.45rem 1rem", borderRadius: "8px", textDecoration: "none", color: "#0d6efd", fontWeight: 600, fontSize: "0.85rem", border: "1px solid #d0e4ff" }}
                      >
                        {p.icon_64 ? <img src={p.icon_64} alt={p.source} style={{ width: "16px", height: "16px" }} /> : <i className="pi pi-external-link" style={{ fontSize: "0.8rem" }} />}
                        {p.source} Profile
                      </a>
                    ))}
                  </div>
                </Section>

                {/* RESUME */}
                <Section title="Resume" icon="pi pi-file-pdf">
                  <Button
                    icon="pi pi-download"
                    label="Download"
                    className="p-button-sm p-button-success ml-auto"
                    style={{ display: "flex", justifyContent: "flex-end", marginTop: "-10px" }}
                    disabled={!hasResume}
                    onClick={() => {
                      if (!candidate.resume?.resumeData) return;

                      try {
                        const base64 = candidate.resume.resumeData.startsWith("data:") ? candidate.resume.resumeData.split(",")[1] : candidate.resume.resumeData;

                        const binary = atob(base64);
                        const bytes = new Uint8Array(binary.length);

                        for (let i = 0; i < binary.length; i++) {
                          bytes[i] = binary.charCodeAt(i);
                        }

                        const blob = new Blob([bytes], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);

                        const link = document.createElement("a");
                        link.href = url;
                        link.download = candidate.resume.filename || "resume.pdf";

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        URL.revokeObjectURL(url);
                      } catch (err) {
                        console.error("Download failed", err);
                      }
                    }}
                  />
                  {/* Row 1 */}
                  <div className="flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                    {/* Row 2 */}
                    <div className="flex justify-content-end gap-2 mb-3">
                      <Button icon="pi pi-minus" disabled={!hasResume || zoom <= 50} onClick={() => setZoom((z) => Math.max(50, z - 10))} tooltip="Zoom out" tooltipOptions={{ position: "bottom" }} />
                      <Button label={`${zoom}%`} disabled={!hasResume} onClick={() => setZoom(100)} tooltip="Reset zoom" tooltipOptions={{ position: "bottom" }} style={{ minWidth: "4rem", fontWeight: 600 }} />
                      <Button icon="pi pi-plus" disabled={!hasResume || zoom >= 200} onClick={() => setZoom((z) => Math.min(200, z + 10))} tooltip="Zoom in" tooltipOptions={{ position: "bottom" }} />
                    </div>

                    {/* View mode */}
                    <div className="flex gap-2">
                      <Button
                        label="Scroll"
                        icon="pi pi-bars"
                        className={viewMode !== "scroll" ? "p-button-outlined p-button-secondary" : ""}
                        disabled={!hasResume}
                        onClick={() => {
                          setViewMode("scroll");
                          setCurrentPage(1);
                        }}
                      />
                      <Button
                        label="Page"
                        icon="pi pi-file"
                        className={viewMode !== "page" ? "p-button-outlined p-button-secondary" : ""}
                        disabled={!hasResume}
                        onClick={() => {
                          setViewMode("page");
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>

                  {/* Viewer */}
                  {/* <div className="border-1 border-round surface-border overflow-hidden" style={{ height: "420px", background: hasResume ? "var(--surface-ground)" : "var(--surface-0)" }}>
                    {hasResume ? (
                      <div className="w-full h-full flex justify-content-center align-items-start" style={{ overflowY: viewMode === "scroll" ? "auto" : "hidden", padding: viewMode === "scroll" ? "12px 0" : 0 }}>
                        <iframe
                          title="resume"
                          src={fileUrl}
                          style={{
                            border: "none",
                            width: `${zoom}%`,
                            height: viewMode === "scroll" ? `${Math.max(600, zoom * 8)}px` : "100%",
                            minWidth: "280px",
                            display: "block",
                            transition: "width 0.2s, height 0.2s",
                          }}
                        />
                      </div>
                    ) : (
                      <div className="w-full h-full flex flex-column align-items-center justify-content-center gap-2 text-color-secondary">
                        <i className="pi pi-file-pdf" style={{ fontSize: "2.5rem", color: "var(--surface-400)" }} />
                        <span className="text-sm">No Resume Available</span>
                      </div>
                    )}
                  </div> */}

                  <div className="border-1 border-round surface-border overflow-hidden" style={{ height: "550px", background: hasResume ? "var(--surface-ground)" : "var(--surface-0)" }}>
                    {hasResume ? (
                      fileUrl ? (
                        <div className="w-full h-full flex justify-content-center align-items-start" style={{ overflowY: viewMode === "scroll" ? "auto" : "hidden", padding: viewMode === "scroll" ? "12px 0" : 0 }}>
                          <iframe
                            src={fileUrl}
                            title="resume"
                            style={{
                              border: "none",
                              width: `${zoom}%`,
                              height: viewMode === "scroll" ? `${Math.max(600, zoom * 8)}px` : "100%",
                              minWidth: "280px",
                              display: "block",
                              transition: "width 0.2s, height 0.2s",
                            }}
                          />
                        </div>
                      ) : (
                        <div className="flex flex-column align-items-center justify-content-center" style={{ width: "100%", height: "100%" }}>
                          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "#0d6efd" }} />
                          <span style={{ color: "#8392a5" }}>Loading...</span>
                        </div>
                      )
                    ) : (
                      <div className="flex flex-column align-items-center justify-content-center text-color-secondary" style={{ width: "100%", height: "100%" }}>
                        <i className="pi pi-file-pdf" style={{ fontSize: "2.5rem" }} />
                        <span>No Resume Available</span>
                      </div>
                    )}
                  </div>

                  {/* Page navigation */}
                  {hasResume && viewMode === "page" && (
                    <div className="flex align-items-center justify-content-center gap-3 mt-2">
                      <Button icon="pi pi-angle-left" disabled={currentPage <= 1} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} />
                      <span className="text-sm font-medium text-color">
                        {/* Page {currentPage} of {totalPages} */}
                        {/* onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} */}
                        Page
                      </span>
                      <Button icon="pi pi-angle-right" />
                    </div>
                  )}
                </Section>
              </div>

              {/*  ════ ════ ════ ════════ RIGHT COLUMN ════ ════ ════ ════ ════ ════ ════ ════ ════ */}

              <div className="col-12 lg:col-4">
                {/* CONTACT */}
                <Section title="Contact" icon="pi pi-phone">
                  <div className="flex gap-2 flex-wrap mb-2">
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "8px" }}>
                      {/* <Button icon="pi pi-comments" label="Message" style={{ flexGrow: 1, minWidth: "130px", border: "1px solid #0d6efd", color: "white", fontWeight: 600, borderRadius: "8px", justifyContent: "center" }} /> */}
                      {candidate.hasEmail && (
                        <Button icon="pi pi-envelope" label="Email" onClick={() => setSendEmail({ open: true, tableData: candidate })} style={{ flexGrow: 1, minWidth: "130px", border: "1px solid #0d6efd", color: "white", fontWeight: 600, borderRadius: "8px", justifyContent: "center" }} />
                      )}
                    </div>
                  </div>
                  {/* Email addresses */}
                  {(candidate?.email || "").length > 0 && (
                    <div className="mt-2">
                      {candidate?.email?.map((e) => (
                        <div key={e} style={{ fontSize: "0.8rem", color: "#495057", marginBottom: "0.2rem" }}>
                          <i className="pi pi-envelope mr-1" style={{ color: "#8392a5", fontSize: "0.75rem" }} />
                          {e}
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ fontSize: "0.8rem", color: "#8392a5", marginTop: "0.5rem" }}>{candidate.hasPhone && (candidate?.phone || []).length > 0 ? `📞 ${(candidate?.phone || []).join(", ")}` : "📵 No phone on file"}</div>
                </Section>

                {/* CANDIDATE ACTIVITY */}
                <Section title="Candidate Activity" icon="pi pi-clock">
                  {[
                    { label: "Resume Last Updated", date: candidate.dateResumeLastUpdated },
                    { label: "Profile Last Updated", date: candidate.dateLastUpdated },
                    { label: "Last Active", date: candidate.dateLastActive },
                  ].map(({ label, date }) => (
                    <div key={label} style={{ marginBottom: "0.9rem" }}>
                      <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "#8392a5", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "0.2rem" }}>{label}</div>
                      <div className="flex align-items-center gap-1" style={{ fontSize: "0.85rem", color: "#495057" }}>
                        <i className="pi pi-clock" style={{ color: "#8392a5", fontSize: "0.75rem" }} />
                        {date ? timeSince(date) : "N/A"}
                      </div>
                    </div>
                  ))}
                </Section>

                {/* PROFILE SOURCE */}
                <Section title="Profile Source" icon="pi pi-database">
                  {candidate.socialProfiles?.map((p) => (
                    <div key={p.source} className="flex align-items-center gap-2 mb-2">
                      {p.icon_64 ? (
                        <img src={p.icon_64} alt={p.source} style={{ width: "24px", height: "24px", borderRadius: "5px" }} />
                      ) : (
                        <div style={{ width: "24px", height: "24px", borderRadius: "5px", background: "#e53935", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <span style={{ color: "#fff", fontWeight: 800, fontSize: "0.7rem" }}>D</span>
                        </div>
                      )}
                      <span style={{ fontWeight: 600, color: "#1a1d23", fontSize: "0.85rem" }}>{p.source} Profile</span>
                    </div>
                  ))}
                </Section>

                {/* EMPLOYER ACTIVITY */}
                <Section title="Employer Activity" icon="pi pi-eye">
                  <div style={{ marginBottom: "0.9rem" }}>
                    <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "#8392a5", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "0.2rem" }}>Last Viewed</div>
                    <div style={{ fontSize: "0.85rem", color: "#495057" }}>
                      <i className="pi pi-eye mr-1" style={{ color: "#8392a5", fontSize: "0.75rem" }} />
                      {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
                    </div>
                  </div>
                </Section>

                {/* PROFILE VIEWS USAGE */}
                {/* {candidate.usage && (
    <Section title="Profile Views" icon="pi pi-chart-bar">
      <div className="flex justify-content-between mb-1" style={{ fontSize: "0.8rem", color: "#8392a5" }}>
        <span>
          Used: <b style={{ color: "#1a1d23" }}>{candidate.usage.viewsConsumed}</b>
        </span>
        <span>
          Remaining: <b style={{ color: "#1a1d23" }}>{candidate.usage.viewsRemaining}</b>
        </span>
      </div>
      <ProgressBar value={Math.round((candidate.usage.viewsConsumed / candidate.usage.quota) * 100)} style={{ height: "8px", borderRadius: "4px" }} />
      <div style={{ fontSize: "0.75rem", color: "#8392a5", marginTop: "0.3rem" }}>Quota: {candidate.usage.quota}</div>
    </Section>
  )} */}

                {/* NOTES */}
                <Section title="Notes" icon="pi pi-pencil">
                  <Button icon="pi pi-eye" label="View Note's" style={{ backgroundColor: "white", color: "black" }} onClick={() => setOpenViewHistory({ open: true, tableData: savedNotes })} />
                  <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Enter notes and click save" rows={4} style={{ width: "100%", borderRadius: "8px", fontSize: "0.85rem", border: "1px solid #dee2e6", resize: "vertical", marginTop: "1rem" }} />
                  <div className="flex justify-content-end mt-2">
                    <Button
                      label="Save"
                      icon="pi pi-save"
                      style={{ background: "#0d6efd", border: "none", fontWeight: 600, borderRadius: "8px" }}
                      onClick={() => {
                        saveCandidateNote();
                        // if (note.trim()) {
                        //   setSavedNotes((prev) => [...prev, note.trim()]);
                        //   setNote("");
                        // }
                      }}
                    />
                  </div>
                  {/* {savedNotes.length > 0 && (
                <div className="mt-2">
                  {savedNotes.map((n, i) => (
                    <div key={i} style={{ background: "#f8f9fb", borderRadius: "8px", padding: "0.55rem 0.85rem", fontSize: "0.82rem", color: "#495057", marginBottom: "0.4rem", border: "1px solid #e5e9f0" }}>
                      {n}
                    </div>
                  ))}
                </div>
              )} */}
                </Section>
                {/* TAGS */}
                {/* <Section title="Tags" icon="pi pi-tag">
              <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
                <Dropdown value={tag} options={tagOptions} onChange={(e) => setTag(e.value)} placeholder="Select a tag" style={{ flex: 1, minWidth: 0, fontSize: "0.85rem" }} />
                <Button
                  icon="pi pi-plus"
                  onClick={() => {
                    if (tag && !addedTags.includes(tag)) {
                      setAddedTags((prev) => [...prev, tag]);
                      setTag(null);
                    }
                  }}
                  style={{ flexShrink: 0, width: "2.2rem", height: "2.2rem", padding: 0, borderColor: "#0d6efd", background: "#0d6efd", color: "#fff", borderRadius: "8px" }}
                />
              </div>

              {addedTags.length > 0 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {addedTags.map((t) => (
                    <Tag key={t} value={t} style={{ background: "#e3f2fd", color: "#1565c0", fontSize: "0.78rem", cursor: "pointer" }} onClick={() => setAddedTags((prev) => prev.filter((x) => x !== t))} />
                  ))}
                </div>
              )}
              <div style={{ marginTop: "0.4rem", fontSize: "0.72rem", color: "#8392a5" }}>Note: Commas are restricted and will be removed.</div>
            </Section> */}

                {/* SIMILAR CANDIDATES */}
                {/* <Button label="Find Similar" icon="pi pi-search" style={{ width: "100%", borderColor: "#0d6efd", color: "bule", fontWeight: 600, borderRadius: "8px" }} /> */}
                {/* <Section title="Similar Candidates" icon="pi pi-users">
    <div className="text-center" style={{ padding: "1rem 0", color: "#8392a5" }}>
      <i className="pi pi-search" style={{ fontSize: "1.8rem", marginBottom: "0.5rem", display: "block" }} />
      <span style={{ fontSize: "0.85rem" }}>Browse similar candidates in TalentSearch</span>
    </div>
  </Section> */}
              </div>
            </div>
          </>
        )}
      </div>
      <SendEmail open={sendEmail.open} tableData={[sendEmail.tableData]} onClose={() => setSendEmail({ open: false, tableData: {} })} toast={props.toast} />
      <Dialog header="Candidate Note's History" visible={openViewHistory.open} style={{ width: "50vw" }} modal onHide={() => setOpenViewHistory({ open: false, tableData: [] })}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" value={openViewHistory.tableData} emptyMessage="No Data found.">
          <Column field="user_Name" header="User Name" />
          <Column field="company_Name" header="Company" />
          <Column field="branchName" header="Branch" />
          <Column field="comments" header="Comment" />
          <Column field="createdOn" header="Searched On" body={(rowData: any) => safeFormatDate(rowData.createdOn, "dd/MM/yyyy", DataFormat)} />
        </DataTable>
      </Dialog>
    </>
  );
}
